import {
  useQuery,
  UseQueryOptions,
  UseQueryResult,
} from '@tanstack/react-query';
import { QueryFetchFunction, QueryTransformer } from 'common/helpers/common';
import {
  ApiError,
  ApiResult,
  ExtendedApiResult,
} from 'common/repositories/common.model';

import {
  getActivitySalesInput,
  getActivitySaleInput,
  ActivitySaleLiteModel,
  ActivitySaleModel,
} from './model';

export function useGetActivitySales(
  input?: getActivitySalesInput,
  options?: UseQueryOptions<
    ExtendedApiResult<ActivitySaleLiteModel[]>,
    ApiError
  >,
): UseQueryResult<ExtendedApiResult<ActivitySaleLiteModel[]>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getActivitySales', input?.params],
      () =>
        QueryFetchFunction({
          url: 'activity-sales',
          params: input?.params,
        }),
      options,
    ),
    ActivitySaleLiteModel,
  );
}

export function useGetActivitySale(
  input?: getActivitySaleInput,
  options?: UseQueryOptions<ApiResult<ActivitySaleModel>, ApiError>,
): UseQueryResult<ApiResult<ActivitySaleModel>, ApiError> {
  return QueryTransformer(
    useQuery(
      options?.queryKey ?? ['getActivitySale', input?.id],
      () => QueryFetchFunction({ url: `activity-sales/${input?.id}` }),
      options,
    ),
    ActivitySaleModel,
  );
}

export function getActivitySalesKey(input?: getActivitySalesInput) {
  return ['getActivitySales', input?.params];
}

export function getActivitySaleKey(input?: getActivitySaleInput) {
  return ['getActivitySale', input?.id];
}
